
import React, { useState, useCallback } from 'react';
import { TabsContent } from '@/components/ui/tabs';
import ErrorBoundary from './ErrorBoundary';

// Import only the necessary components
import AdminHeader from './admin/AdminHeader';
import TabsContainer from './admin/tabs/TabsContainer';
import ErrorLogPanel from './admin/ErrorLogPanel';
import { useErrorNotification } from './admin/hooks/useErrorNotification';

const AdminPanel: React.FC = () => {
  const [activeTab, setActiveTab] = useState('errors');
  
  // Set up a callback for tab changes
  const handleTabChange = useCallback((value: string) => {
    setActiveTab(value);
  }, []);
  
  // Use our custom hook for error management with the callback
  const { recentErrors, handleClearErrors } = useErrorNotification(activeTab, setActiveTab);
  
  return (
    <div className="container py-8">
      <AdminHeader />
      
      <TabsContainer 
        activeTab={activeTab} 
        errorCount={recentErrors.length}
        onTabChange={handleTabChange}
        errorLogsOnly={true} // Ensure this is set to true to show only Error Logs tab
      >
        <TabsContent value="errors">
          <ErrorBoundary>
            <ErrorLogPanel errors={recentErrors} onClearErrors={handleClearErrors} />
          </ErrorBoundary>
        </TabsContent>
      </TabsContainer>
    </div>
  );
};

export default AdminPanel;
